import {AbstractControl, ValidatorFn} from "@angular/forms";
import * as moment from 'moment';
import * as _ from 'lodash';

export function checkDatePeriod(): ValidatorFn {
  return (control: AbstractControl) : {[key: string] : any}| null  => {
    if (control && control.parent) {
      let effectiveStartDate = control.parent.get('effectiveStartDate').value;
      if (_.isNil(effectiveStartDate)) {
        effectiveStartDate = new Date();
      }
      const effectiveEndDate = control.parent.get('effectiveEndDate').value;
      control.parent.get('effectiveStartDate').setErrors(null);
      control.parent.get('effectiveEndDate').setErrors(null);
      if (!_.isNil(effectiveEndDate) && moment(effectiveEndDate).isBefore(moment(effectiveStartDate))) {
        return {invalidPeriod: true};
      }
    }
    return null;
  }
}
